module.exports = __webpack_public_path__ + "static/media/name_03.61c969d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/name_03.png
// module id = 1825
// module chunks = 0 1